import { BaseEntity } from "yt-ng-framework";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";
export class EOtpremnicaView extends BaseEntity{

    constructor(){
        super();
    }

    BrojOtpremnice: string;
    Datum: NgbDate;    
    Komitent: string; 
    KomitentMesto: string; 
    StatusGenericName: string;
    StatusColor:string;
    StatusTooltip:string;
    OsvezivogStatusa:boolean;
    MasterDokumID: number;
    NoviKomitent: boolean;  
    KomitentPosiljalac: string;
    KomitentPosiljalacMesto: string;
    ProvajderID: number; 
    BrojIzlaznePrijemnice: string;
    BrojUlazneOtpremnice: string;

    Deserialize(input: any){
        this.ID = input.ID;
        this.BrojOtpremnice = input.BrojDokumenta;
        this.Datum = input.Datum;
        this.Komitent = input.Komitent;
        this.KomitentMesto = input.KomitentMesto;
        this.StatusGenericName = input.StatusGenericName;
        this.StatusColor=input.StatusColor;
        this.StatusTooltip= input.StatusTooltip;
        this.OsvezivogStatusa = input.OsvezivogStatusa;
        this.MasterDokumID=input.MasterDokumID;
        this.StatusGenericName = input.StatusGenericName;
        this.StatusColor = input.StatusColor;
        this.StatusTooltip = input.StatusTooltip;
        this.KomitentPosiljalac = input.KomitentPosiljalac;
        this.KomitentPosiljalacMesto = input.KomitentPosiljalacMesto;
        this.ProvajderID = input.ProvajderID;
        this.NoviKomitent = input.NoviKomitent;
        this.BrojIzlaznePrijemnice = input.BrojIzlaznePrijemnice;
        this.BrojUlazneOtpremnice = input.BrojUlazneOtpremnice;
        return this;
    }

    Serialize(input: EOtpremnicaView){
        return input;
    }
}